export default __webpack_public_path__ + "static/media/mercurymarathon@2x.50438a4f.png";